<template>
  <div>
    <div id="notifications"></div>
    <router-view :key="$route.params.siteId"/>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
  @import url(~@fortawesome/fontawesome-free/css/all.min.css);
  @import "assets/css/w3.css";
  @import "assets/css/footer.css";
  @import "assets/css/header.css";
  @import "assets/css/notifications.css";
  @import "assets/css/screenSize.css";
  @import "assets/css/style.css";
</style>
